// Generate a consistent color based on the item name with more variety
export const getColorFromName = (str: string, seed: number = 0): string => {
  let hash = seed;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Generate hue with better distribution (0-360)
  const hue = Math.abs(hash % 360);
  
  // Pastel colors: lower saturation (40-65%)
  const saturation = 40 + (Math.abs(hash >> 8) % 26);
  
  // Pastel colors: higher lightness (65-80%) for soft, gentle appearance
  const lightness = 65 + (Math.abs(hash >> 16) % 16);
  
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

// Extract initials from name
export const getInitials = (str: string): string => {
  const words = str.trim().split(/\s+/);
  if (words.length === 1) {
    // Single word: take first 2 characters
    return words[0].substring(0, 2).toUpperCase();
  }
  // Multiple words: take first letter of first 2-3 words
  return words
    .slice(0, 3)
    .map(word => word[0])
    .join('')
    .toUpperCase();
};
